/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiesactiongrow2Inputs */

const en_opportunitiesactiongrow2 = /** @type {(inputs: Opportunitiesactiongrow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thin supply - add partners`)
};

const de_opportunitiesactiongrow2 = /** @type {(inputs: Opportunitiesactiongrow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dünnes Angebot - Partner gewinnen`)
};

/**
* | output |
* | --- |
* | "Thin supply - add partners" |
*
* @param {Opportunitiesactiongrow2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesactiongrow2 = /** @type {((inputs?: Opportunitiesactiongrow2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesactiongrow2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesactiongrow2(inputs)
	return de_opportunitiesactiongrow2(inputs)
});
export { opportunitiesactiongrow2 as "opportunitiesActionGrow" }